import React from "react";
import Button from "../../components/EmptyButton";
import universityImage from "../../assets/images/university-tech.jpg";
import { FaGraduationCap, FaSchool, FaUsers } from "react-icons/fa";
import { BsRocket, BsRocketTakeoff } from "react-icons/bs";
import { FiBarChart, FiSettings, FiZap } from "react-icons/fi";
import { LuGraduationCap } from "react-icons/lu";
import { useHistory } from "react-router-dom";

const UniversitySection = () => {
  const history = useHistory()
  const benefits = [
    {
      icon: FiBarChart,
      title: "Increase Student Success Rates",
      description: "Proven methods to improve academic outcomes",
    },
    {
      icon: FiZap,
      title: "Automate Tutoring Programs",
      description: "Scale personalized support efficiently",
    },
    {
      icon: FaUsers,
      title: "Career Mentoring Integration",
      description: "Comprehensive student development",
    },
    {
      icon: FiSettings,
      title: "Seamless LMS Integration",
      description: "Easy implementation with existing systems",
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-secondary/20 via-background to-secondary/30">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Image */}

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-floating">
              <img
                src={universityImage}
                alt="University with technology integration"
                className="w-full h-full object-cover"
              />
              <div
                
                className="absolute inset-0 bg-gradient-to-tr from-primary/30 to-transparent univerityImageGrad"
              ></div>
            </div>

            {/* Floating Elements */}
            <div
              className="absolute bg-white -top-4 -left-4 bg-card p-4 border rounded-lg shadow-elegant text-center"
              style={{ borderColor: "#f7f7f7" }}
            >
              <div
                className="text-primary"
                style={{
                  fontWeight: "700",
                  fontSize: "1.5rem",
                  lineHeight: "2rem",
                }}
              >
                90%
              </div>
              <span
                className="text-muted-foreground"
                style={{
                  fontSize: "0.75rem",
                  lineHeight: "1rem",
                  color: "#78726d",
                }}
              >
                Success Rate
              </span>
            </div>

            <div
              className="flex absolute bg-white -bottom-4 border -right-4 bg-card p-4 rounded-lg shadow-elegant"
              style={{ borderColor: "#f7f7f7" }}
            >
              <FaSchool className="w-5 h-5 text-primary" />
              <span
                className="mt-0.5 ml-2"
                style={{
                  fontWeight: "500",
                  fontSize: "0.875rem",
                  lineHeight: "1.25rem",
                }}
              >
                Transform Education
              </span>
            </div>
          </div>

          {/* Right Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <div
                className="text-primary border rounded-xl flex items-center w-fit px-2 py-1 w-48"
                style={{ backgroundColor: "#ffe2cf" }}
              >
                <BsRocketTakeoff className="w-4 h-4 mr-2" />
                Pilot Program
              </div>
              <h2
                style={{ fontSize: "3rem", fontWeight: "700", lineHeight: "1" }}
                className="font-bold text-foreground"
              >
                Transform Your
                <span className="block text-primary">
                  University's Education
                </span>
              </h2>
              <p
                style={{
                  color: "#78726d",
                  lineHeight: "1.625",
                  fontSize: "1.25rem",
                }}
                className="text-xl text-muted-foreground leading-relaxed"
              >
                We are now launching a pilot program for universities and
                colleges. Try our revolutionary technology that helps transform
                education and increase student success rates.
              </p>
            </div>

            <div className="space-y-4">
              <h3
                className="text-foreground"
                style={{ fontSize: "1.125rem", fontWeight: "600" }}
              >
                What our pilot program offers:
              </h3>
              <div className="grid grid-cols-1 gap-4">
                {benefits.map((benefit, index) => (
                  <div
                    key={index}
                    style={{ borderColor: "#f7f7f7" }}
                    className="flex items-start space-x-4 p-4 bg-white rounded-lg border hover:shadow-card transition-all duration-300"
                  >
                    <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <benefit.icon
                        className="text-white"
                        style={{ fontSize: "1.5rem" }}
                      />
                    </div>
                    <div>
                      <h4 className="font-semibold text-foreground">
                        {benefit.title}
                      </h4>
                      <p className="text-sm text-muted-foreground">
                        {benefit.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div
              className="rounded-lg p-6 space-y-4"
              style={{ backgroundColor: "#f5f2f080" }}
            >
              <h3 className="text-foreground" style={{ fontWeight: "600" }}>
                Key Features:
              </h3>
              <ul className="space-y-2">
                {[
                  "Automate tutoring and career mentoring programs on our platform",
                  "Integrate Clara AI in your learning management system",
                  "Provide 24/7 AI assistance to your students",
                  "Access comprehensive analytics and progress tracking",
                  "Seamless integration with existing university systems",
                ].map((feature, index) => (
                  <li key={index} className="flex items-center space-x-3">
                    <LuGraduationCap className="w-5 h-5 text-primary flex-shrink-0" />
                    <span
                      className="text-muted-foreground"
                      style={{
                        fontSize: "0.875rem",
                        lineHeight: "1.25rem",
                        color: "#78726d",
                      }}
                    >
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <div className="" style={{ width: "250px" }}>
                <Button onClick={() => {
                  history.push('/pilot-onboard')
                }} filled={true} className="text-lg px-4 w-24">
                  Join Pilot Program
                </Button>
              </div>
              <div className="" style={{ width: "250px" }}>
                <Button
                  variant="hero-outline"
                  size="lg"
                  className="text-lg px-8"
                  onClick={() =>
                    window.open(
                      "https://calendly.com/nini-studycrowdai/transform-student-success-with-studycrowd-ai",
                      "_blank"
                    )
                  }
                >
                  Schedule Demo
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UniversitySection;
